import { SxProps, TextField, TextFieldProps, Theme } from '@mui/material'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'

export type FormInputProps<T extends FieldValues> = {
    name: Path<T>
    control: Control<T>
    label: any
    setValue?: any
    sx?: SxProps<Theme>
    type?: React.InputHTMLAttributes<unknown>['type']
    disabled?: boolean
    rows?: string | number
    readonly?: boolean
} & TextFieldProps
const FormInputText = <T extends FieldValues>({
    name,
    control,
    label,
    sx,
    type,
    disabled,
    rows,
    slotProps,
    // inputProps,
    // InputProps,
    placeholder,
    variant,
    inputRef,
    readonly,
    helperText,
}: FormInputProps<T>) => {
    return (
        <Controller
            name={name}
            control={control}
            render={(renderProps) => (
                <TextField
                    name={name}
                    type={type}
                    onChange={renderProps.field.onChange}
                    value={renderProps.field.value || ''}
                    error={!!renderProps.fieldState.error}
                    helperText={
                        !!renderProps.fieldState?.error
                            ? renderProps.fieldState.error.message
                            : helperText || null
                    }
                    fullWidth
                    label={label}
                    sx={sx}
                    variant={variant || 'outlined'}
                    // disabled={disabled}
                    slotProps={{
                        ...slotProps,
                        input: {
                            ...slotProps?.input,
                            readOnly: readonly,
                        },
                    }}
                    disabled={disabled}
                    rows={rows}
                    multiline={Boolean(rows)}
                    placeholder={placeholder}
                    inputRef={inputRef}
                />
            )}
        />
    )
}

export default FormInputText
